import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import Root from "./Root/Root";
import AboutUs from "./Pages/AboutUs/AboutUs";
import SchemeForm from "./Pages/PolicySchemeBuy/SchemeBuy";

// Auth
import Signup from "./Components/Auth/SignUp";
import Login from "./Components/Auth/LogIn";
import OtpVerifyForm from "./Components/Auth/otpVerify";
import CustomerProfile from "./Components/Auth/CustomerAuth/CustomerProfile";
import BrokerProfile from "./Components/Auth/BrokerAuth/BrokerProfile";
import ResetPassword from "./Components/Auth/ResetPassword";
import useVendorStore from "./AuthStore/store/authStore";
import { Toaster } from "react-hot-toast";


// Pages
import Contact from "./Pages/Contact/Contact";
import Courses from "./Pages/Cources/Courses";
import BrokerDashboard from "./Components/Dashboard/BrokerDashboard";
import UserDashboard from "./Components/Dashboard/CustomerDashboard";
import MutualFunds from "./Pages/MutualFunds/MutualFunds";
import NotFoundPage from "./Pages/Error/Error";
import Faqs from "./Pages/Faqs/Faqs";
import TandC from "./Pages/Legal/TandC";
import PrivacyPolicy from "./Pages/Legal/PrivacyPolicy";
import MyForm from "./Components/Modal/MyFrome";

// 🔒 ProtectedRoute without role prop



const ProtectedRoute = ({ children, type }) => {
  const { isAuthenticated, authToken, isVendor, isCustomer, isverify } =
    useVendorStore();

  // Must be logged in and verified
  if (!isAuthenticated || !authToken || !isverify) {
    return <Navigate to="/log-in" replace />;
  }

  // Vendor-only route
  if (type === "vendor" && !isVendor) {
    return <Navigate to="/log-in" replace />;
  }

  // Customer-only route
  if (type === "customer" && !isCustomer) {
    return <Navigate to="/log-in" replace />;
  }

  return <><div className="mt-32">{children}</div></>;
};


// Router setup
const Routes = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      { path: "/", element: <App /> },
      { path: "/about-us", element: <AboutUs /> },
      { path: "/courses", element: <Courses /> },
      { path: "/contact", element: <Contact /> },
      { path:"/faqs", element:<Faqs/>},
      { path:"/terms-and-conditions", element:<TandC/>},
      { path:"/privacy-policy", element:<PrivacyPolicy/>},
      { path:"/my-from-test", element:<MyForm/>},


      { path: "/policy-buy", element:

        <>
        <ProtectedRoute>
         <SchemeForm />
         </ProtectedRoute>
         </>
       },
       {
        path:'/mutual-funds',
        element: 
        <>
        <ProtectedRoute>
          <MutualFunds/>
        </ProtectedRoute>
        </>
       },
      
      // Auth
      { path: "/sign-up", element: <Signup /> },
      { path: "/auth/otp-verify", element: <OtpVerifyForm/> },
      { path: "/log-in", element: <Login /> },
      { path: "/reset-password", element: <ResetPassword /> },

      // Profiles (accessible after login, no strict role check)
      { path: "/customer-profile", element: <CustomerProfile /> },
      { path: "/broker-profile", element: <BrokerProfile /> },

      // Dashboards with role restriction
      {
        path: "/auth/verify/broker-dashbord",
        element: (
          <ProtectedRoute type="vendor">
            <BrokerDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/auth/verify/customer-dashbord",
        element: (
          <ProtectedRoute type="customer">
            <UserDashboard />
          </ProtectedRoute>
        ),
      },

      // 404 Page
      {
        path: "*",
        element: (
          <div className="min-h-screen mt-20">
           <NotFoundPage/>
          </div>
        ),
      },
    ],
  },
]);




// Mount app
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
     <StrictMode>
      <div> <Toaster position="top-center" reverseOrder={true} /></div>
    <RouterProvider router={Routes} />
    </StrictMode>

);
